









































































































import {
  Component,
  Prop,
  Vue,
  Mixins,
  Ref,
  Watch,
} from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import { SettingEntry } from "@/models/Setting";
import UserRoleSelect from "@/components/User/RoleSelect.vue";
import UserTitleSelect from "@/components/User/TitleSelect.vue";
import { User } from "../../models";
import UsersMixin from "@/mixins/http/UsersMixin";
import DisplayErrors from "@/components/DisplayErrors.vue";
import IUser from "../../models/interfaces/IUser";
import { showToast } from "../../utils/RailsRoutes";
import { UserPayload } from "../../models/User";
import { capitalize } from "../../utils/Typography";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "../../store/types/RequestData";

const updateTag = "update_user";
const createTag = "create_user";

@Component({
  components: {
    VModal,
    UserRoleSelect,
    UserTitleSelect,
    DisplayErrors,
  },
})
export default class UserEditModal extends Mixins(UsersMixin) {
  @RegisterHttp(createTag) createRequest: RequestData;
  @RegisterHttp(updateTag) updateRequest: RequestData;
  item: UserPayload = null;
  @Ref() readonly modal!: VModal;
  content = "";
  isNew = false;

  canceled!: Function | null;

  onRoleChanged(role: string) {
    this.item.role = role;
  }

  onTitleChanged(title: string) {
    this.item.title = title;
  }

  get valid() {
    return (
      this.item?.firstName &&
      this.item?.lastName &&
      this.item?.email &&
      this.item?.role
    );
  }

  @Watch("item.firstName", { deep: true })
  onFirstNameChanged(value: string, oldValue: string | undefined) {
    if (value && oldValue) {
      this.item.firstName = capitalize(value);
    }
  }

  @Watch("item.lastName", { deep: true })
  onLastChanged(value: string, oldValue: string | undefined) {
    if (value && oldValue) {
      this.item.lastName = capitalize(value);
    }
  }

  title() {
    return `${this.isNew ? "Add" : "Edit"} user`;
  }

  get confirmLabel() {
    return `${this.isNew ? "CREATE" : "UPDATE"} user`;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
  }

  protected onConfirm() {
    if (this.valid) {
      this.$emit("confirmed", this.item);
      this.modal.hide();
    }
  }

  protected onHidden() {
    this.reset();
    if (this.canceled) {
      this.canceled();
    }
  }

  edit(item: IUser) {
    this.isNew = false;
    this.modal.show();
    this.item = new UserPayload();
    this.item.fromData(item);
  }

  create(companyId) {
    this.isNew = true;
    this.modal.show();
    this.item = new UserPayload();
    this.item.companyId = companyId;
  }

  reset() {
    this.item = null;
  }

  async save() {
    try {
      const user = this.isNew
        ? await this.createUser(this.item, createTag)
        : await this.updateUser(this.item, updateTag);
      const emitTag = this.isNew ? "created" : "updated";
      this.$emit(emitTag, user);
      this.modal.hide();
      showToast("User saved successfully!");
    } catch (err) {
      showToast("An error occurred while saving user: " + err, {
        type: "error",
      });
    }
  }
}
